import { useMemo } from 'react';
import { GameMode } from '../lib/types';
import { MenuButton } from '../MainMenu/mainMenu.styles';
import { MenuContainer, ModeLabel } from './game.styles';

type MenuProps = {
  mode: GameMode;
  resume: () => void;
  restart: () => void;
  exit: () => void;
};

export default function Menu({ mode, resume, restart, exit }: MenuProps) {
  const label = useMemo(() => GameMode[mode], [mode]);
  return (
    <MenuContainer>
      <ModeLabel>{label}</ModeLabel>
      <MenuButton onClick={resume}>Resume</MenuButton>
      {mode !== GameMode.Tutorial && (
        <MenuButton onClick={restart}>Restart</MenuButton>
      )}
      <MenuButton onClick={exit}>Exit</MenuButton>
    </MenuContainer>
  );
}
